// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"e47f7b55562b59738e26","452":"0378097489158c55acc0","453":"4259ad9a7d68844f40cd","522":"3f85873167338c977979","551":"899af47b98c1e1ca5a2b"}[chunkId] + ".js";
};